export default "__VITE_ASSET__C_2a3pWz__"